<template lang="pug">
    // DatePicker
    div
        v-menu(
            max-width="290px"
            full-width
            v-model="menuDate"
            :close-on-content-click="false"
        )
            template(v-slot:activator="{ on }")
                v-text-field.marginRight(
                    append-icon="expand_more"
                    v-on="on"
                    readonly
                    outline
                    hide-details
                    :value="date | formattedDate"
                    :label="label"
                )

            v-date-picker(
                name="datePicker"
                color="primary"
                no-title
                v-model="date"
                :min="currentDay"
                @change="setDate"
            )
</template>

<script>
    import dayjs from 'dayjs';
    import VueTypes from 'vue-types';
    import formattedDate from '~filters/FormattedDate';

    export default {
        props: {
            label: VueTypes.string.def('Date From'),
            datePickerCallback: VueTypes.func.def(() => {}),
            predefinedDate: VueTypes.string.def('')
        },
        filters: {
            formattedDate
        },
        data() {
            return {
                currentDay: dayjs().format('YYYY-MM-DD'),
                menuDate: false,
                date: this.predefinedDate
            };
        },
        methods: {
            setDate() {
                this.menuDate = false;
                this.datePickerCallback(this.date);
            }
        }
    };
</script>
